import debounce from 'lodash/debounce'
import { useGetDepartmentsLazy } from 'domains/merchandising/api/departments/getDepartments.hooks'
import { useGetCollectionsLazy } from 'domains/merchandising/api/hero-banners/getCollectionsBannerDestination.hooks'
import { useGetProductsByNameLazy } from 'domains/merchandising/api/hero-banners/getProductsByName.hooks'
import { useGetRetailerConfiguration } from 'domains/merchandising/api/getRetailerConfiguration.hooks'

const DEBOUNCE_DELAY = 300

export const useHeroBannerFormLinkDestination = ({ retailerId }) => {
  const { retailerConfiguration } = useGetRetailerConfiguration({ retailerId })

  const {
    loading: departmentsLoading,
    error: departmentsError,
    departments,
    getDepartments,
  } = useGetDepartmentsLazy()

  const {
    loading: collectionsLoading,
    error: collectionsError,
    collections,
    getCollections,
  } = useGetCollectionsLazy()

  const {
    loading: productsLoading,
    error: productsError,
    products,
    getProductsByName,
  } = useGetProductsByNameLazy()

  const departmentOptions = departments.map(department => ({
    value: department.id,
    label: department.name,
  }))

  const collectionOptions = collections.map(collection => {
    const value = JSON.stringify({
      slug: collection.slug,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      legacy_path: `collections/${collection.slug}`,
    })
    return {
      value,
      label: collection.name,
    }
  })

  const productOptions = products.map(product => ({
    value: product.productId,
    label: product.displayName,
  }))

  return {
    retailerConfiguration,
    getDepartments,
    getCollections,
    getProductsByName: debounce(getProductsByName, DEBOUNCE_DELAY),
    loading: departmentsLoading || collectionsLoading || productsLoading,
    departmentsError,
    collectionsError,
    productsError,
    departmentOptions,
    collectionOptions,
    productOptions,
  }
}
